import { useEffect, useState } from 'react'
import {
  downloadAdminProblemReportAttachment,
  downloadOwnProblemReportAttachment,
} from '../../api/generated/problem-reports/problem-reports'
import { Button } from '../../components/ui/button'
import { useT } from '../../i18n'
import { reportCopy } from './copy'
import { useReportRead, safeReportImageUrl } from './own-data'
export default function PrivateReportImage({
  id,
  fileId,
  audience,
  mimeType,
}: {
  id: string
  fileId: string
  audience: 'own' | 'admin'
  mimeType: string
}) {
  const t = useT(reportCopy)
  const [expiredGrant, setExpiredGrant] = useState<object | null>(null)
  const query = useReportRead([audience, 'image', id, fileId], (options) =>
    (audience === 'admin'
      ? downloadAdminProblemReportAttachment
      : downloadOwnProblemReportAttachment)(
      id,
      fileId,
      { variant: 'original' },
      options,
    ),
  )
  const grant = query.data?.status === 200 ? query.data.data : null
  useEffect(() => {
    if (!grant) return
    const timeout = window.setTimeout(
      () => setExpiredGrant(grant),
      Math.max(0, Math.min(60_000, Date.parse(grant.expires_at) - Date.now())),
    )
    return () => window.clearTimeout(timeout)
  }, [grant])
  const url =
    grant && grant !== expiredGrant ? safeReportImageUrl(grant.url) : null
  return (
    <div className="space-y-2">
      {url && (mimeType.startsWith('video/') ? (
        <video src={url} aria-label={t.video} controls playsInline preload="metadata"
          className="max-h-72 w-full rounded-[var(--radius-control)]" />
      ) : (
        <img
          src={url}
          alt={t.image}
          referrerPolicy="no-referrer"
          className="h-auto w-full rounded-[var(--radius-control)]"
        />
      ))}
      {query.isPending && <p role="status">{t.loading}</p>}
      <Button
        size="sm"
        variant="outline"
        disabled={query.isFetching}
        onClick={() => {
          void query.refetch()
        }}
      >
        {t.refreshImage}
      </Button>
    </div>
  )
}
